"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COMMON_LOGO = void 0;
const COMMON_LOGO = exports.COMMON_LOGO = 'common';